/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountDomainInfo {
    getFixupPrototypeFunction() { return MasterAccountDomainInfo.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountDomainInfo>): MasterAccountDomainInfo {
        let obj = Object.assign(new MasterAccountDomainInfo(), model);
        MasterAccountDomainInfo.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountDomainInfo>): MasterAccountDomainInfo {
        if (!model) return null;
        return MasterAccountDomainInfo.newInstance(<MasterAccountDomainInfo> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountDomainInfo) {
        if (!obj) return;

        models.MasterAccountDomainInfo.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountDomainInfo): boolean {
        Object.setPrototypeOf(obj, MasterAccountDomainInfo.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Domain Name
     */
    domain_name: string;

    /**
     * list of role ids
     */
    role_ids: Array<string>;

    /**
     * Flag set to allow auto signup for new users
     */
    allow_auto_signup: boolean;

}
